import { useRef } from 'react'

import { FieldArray, FormikProvider } from 'formik'

import SettingsPortal from '../../components/SettingsPortal'

import ChatInput from '../../components/ChatInput'
import TextChatWindow from '../../components/TextChatWindow'
import { StyledBody, StyledChatHeader, StyledRoot } from '../Cortext/Cortext'
import { StyledSettings } from '../Cortext/Settings/SettingsStyles.css'
import { useBitAgent } from './useBitAgent'
import FormikTextField from 'components/TextFieldFormik'
import TextareaFormik from 'components/TextareaFormik'
import { ButtonPrimary, ButtonTertiary } from 'components/Button/Button'
import styled from 'styled-components'
import SubnetDescription from '../../components/SubnetDescription'
import ChatHistoryList from '../../components/History/ChatHistoryList'
import Examples from '../../components/Examples'
import { examples } from '../TextPrompting/types'

const BitAgent = () => {
    const bitAgentRef = useRef(null)

    const {
        responseLoading,
        formik,
        chat,
        handleStartNewChat,
        chatHistory,
        setChat,
        handleDeleteHistory,
        scrollRef,

        handleStopRequest,
    } = useBitAgent()

    return (
        <FormikProvider value={formik}>
            <StyledRoot ref={bitAgentRef}>
                <ChatHistoryList
                    onNewChat={handleStartNewChat}
                    chatHistory={chatHistory}
                    handleDeleteHistory={handleDeleteHistory}
                    setChat={setChat}
                    chat={chat}
                />

                <StyledBody>
                    <StyledChatHeader />

                    <TextChatWindow
                        loading={responseLoading}
                        messages={chat.messages}
                        scrollRef={scrollRef}
                    />

                    <ChatInput
                        formik={formik}
                        fieldName='prompt'
                        stopRequest={{
                            requestLoading: responseLoading,
                            handleStopRequest,
                        }}
                    />
                </StyledBody>
            </StyledRoot>

            <SettingsPortal portalRef={bitAgentRef}>
                <StyledSettings>
                    <SubnetDescription
                        noImage
                        title={'20. BitAgent'}
                        description={
                            'Empowers users to seamlessly integrate intelligent agents, providing personalized assistance and integrated task automation.'
                        }
                        docUrl={`${import.meta.env.REACT_APP_SUBNET_DOCS_URL}/bit-agent`}
                    />

                    <Examples
                        disabled={responseLoading}
                        formik={formik}
                        chatInputName={'prompt'}
                        examples={examples}
                    />

                    <FieldArray name='datas'>
                        {({ push, remove, form }) => (
                            <>
                                {form.values.datas.map(
                                    (data: { source: string; context: string }, index: number) => (
                                        <StyledColumn key={index}>
                                            <FormikTextField
                                                name={`datas[${index}].source`}
                                                placeholder={'source'}
                                                label={`Data ${index + 1}`}
                                            />
                                            <TextareaFormik
                                                label={''}
                                                value={data.context}
                                                fieldName={`datas[${index}].context`}
                                                placeholder='context'
                                            />
                                            {form.values.datas.length > 1 && (
                                                <ButtonTertiary onClick={() => remove(index)}>
                                                    Remove
                                                </ButtonTertiary>
                                            )}
                                        </StyledColumn>
                                    ),
                                )}
                                <ButtonPrimary onClick={() => push({ source: '', context: '' })}>
                                    Add Data
                                </ButtonPrimary>
                            </>
                        )}
                    </FieldArray>
                </StyledSettings>
            </SettingsPortal>
        </FormikProvider>
    )
}

export default BitAgent

const StyledColumn = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
`
